import styled from '@emotion/styled';

import leaf from '@assets/images/leaf.svg';

export const UpdateProfileFormContainer = styled.div`
  min-height: 100%;
  background: url(${leaf}) no-repeat bottom right 7%;
`;
